import { render } from "./ProfileInfo.vue?vue&type=template&id=2bfbd10d&ts=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__